import * as venueActions from 'actions/venue';

const initialState = {
  fetchingAuthorisedUsers: false,
  authorisedUsersFetched: false,
  authorisedUsersError: null,
  authorisedUsers: [],
  fetchingManagedPages: false,
  managedPagesFetched: false,
  managedPagesError: null,
  managedPagesQueryable: false,
  managedPages: [],
  fetchingFatsomaPage: false,
  fatsomaPageFetched: false,
  fatsomaPageError: null,
  fatsomaPage: null,
  selectedSubscriptionUser: null,
  fetchingDefaultVenue: false,
  fetchingVenue: false,
  updatingVenue: false,
  venueUpdated: false,
  creatingVenue: false,
  venueCreated: false,
  defaultVenue: null,
  uploadedImageURL: null,
  uploadingImage: false,
  fetchingAuthorizedVenues: false,
  fetchingMenus: false,
  menus: null,
  venueSwitcherSearchResults: [],
  errorFetchingMenus: false,
  _id: null,
  name: '-',
};

const venueReducer = (state = initialState, action) => {
  switch (action.type) {
    case venueActions.BEGIN_IMAGE_UPLOAD:
    case venueActions.FINISH_IMAGE_UPLOAD:
    case venueActions.SET_UPLOADED_IMAGE_URL:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_DEFAULT_VENUE:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_CREATE_VENUE:
      return { ...state, ...action.payload };
    case venueActions.SET_VENUE_CREATED:
      return { ...state, ...action.payload };
    case venueActions.SET_DEFAULT_VENUE:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_VENUE_DETAILS:
      return { ...state, ...action.payload };
    case venueActions.SET_VENUE_DETAILS:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_AUTHORIZED_VENUES:
      return { ...state, ...action.payload };
    case venueActions.RECEIVE_AUTHORIZED_VENUES:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_ALL_MENUS:
      return { ...state, ...action.payload };
    case venueActions.RECEIVE_ALL_MENUS:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_UPDATE_VENUE:
      return { ...state, ...action.payload };
    case venueActions.VENUE_UPDATED:
      return { ...state, ...action.payload };
    case venueActions.SET_VENUE_STRIPE_TOKEN:
      return { ...state, ...action.payload };
    case venueActions.CLEAR_VENUE_DETAILS:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_AUTHORISED_USERS:
      return { ...state, ...action.payload };
    case venueActions.SET_AUTHORISED_USERS:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_MANAGED_PAGES:
      return { ...state, ...action.payload };
    case venueActions.SET_MANAGED_PAGES:
      return { ...state, ...action.payload };
    case venueActions.REQUEST_FATSOMA_PAGE:
      return { ...state, ...action.payload };
    case venueActions.SET_FATSOMA_PAGE:
      return { ...state, ...action.payload };
    case venueActions.SET_SELECTED_SUBSCRIPTION_USER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default venueReducer;



// WEBPACK FOOTER //
// ./src/reducers/venue/index.js